// Width of the trailing action column in the Story Ideas list view, shared by the
// row (StoryIdeaCardList) and the column header (search/infinite_hits) so their
// columns — most visibly the "Posted" column — stay aligned. The row fills this
// column with its content; the header reserves it as empty space. Signed-in rows
// hold the message + call-for-sources buttons (36px each) plus the save bookmark
// (18px icon), each separated by a 6px gap; signed-out rows have no action column.
const storyIdeaListActionColumnWidth = (isSignedIn) => (isSignedIn ? 108 : 0);

export default storyIdeaListActionColumnWidth;
